var render = function render2() {
  var _vm = this, _c = _vm._self._c;
  return _vm.anchor ? _c("a", _vm._g({ class: {
    styles: _vm.styles,
    "cursor-pointer": !_vm.disabled
  } }, _vm.anchorListeners), [_c("span", [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2)]) : _c("button", _vm._g({ staticClass: "flex items-center whitespace-nowrap hover:bg-wblue-200", class: _vm.styles, attrs: { "disabled": _vm.disabledButton, "type": _vm.buttonType, "aria-label": _vm.label } }, _vm.$listeners), [_c("div", { staticClass: "flex items-center justify-center" }, [_vm._t("start-icon"), _vm._t("default"), _vm.loading ? _c("AppSpinner") : _vm.label ? _c("span", [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._t("end-icon")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
